// صفحة مهام رند - التصميم والمنطق موحّدين بـ components/EmployeeTasksPage.jsx
import React from "react";
import EmployeeTasksPage from "./components/EmployeeTasksPage";

const RandTasks = () => (
  <EmployeeTasksPage employeeName="رند" title="رند" backPath="/rand" />
);

export default RandTasks;
